import { createSlice } from "@reduxjs/toolkit";
import { brandGetLandingPageWithProducts } from "./brandAsyncThunk";

const brandGetLandingPageWithProductSlice = createSlice({
  name: "brand",
  initialState: {
    payload: [],
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [brandGetLandingPageWithProducts.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [brandGetLandingPageWithProducts.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = [...action.payload.list];
    },
    [brandGetLandingPageWithProducts.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default brandGetLandingPageWithProductSlice.reducer;
